/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_LatestInputs */

const en_blog_latest = /** @type {(inputs: Blog_LatestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest stories`)
};

const zh_blog_latest = /** @type {(inputs: Blog_LatestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新文章`)
};

/**
* | output |
* | --- |
* | "Latest stories" |
*
* @param {Blog_LatestInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const blog_latest = /** @type {((inputs?: Blog_LatestInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_LatestInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_latest(inputs)
	return zh_blog_latest(inputs)
});
export { blog_latest as "blog.latest" }